import Api from '..';

// =============================================================================
// SERVICE: COMUNICADOS (Server-Driven UI - web admin)
// =============================================================================
// Endpoints do backend criado no backend (TPEDF-API):
//   GET    /comunicados                 - lista todos (com filtros)
//   POST   /comunicados                 - cria novo
//   GET    /comunicados/:id             - pega 1
//   DELETE /comunicados/:id             - desativa
//   POST   /comunicados/:id/disparar    - dispara push FCM
//   GET    /comunicados/:id/respostas   - lista respostas
//   GET    /comunicados/:id/estatisticas - grafico
// =============================================================================

const ComunicadosService = {

    // 1. Listar todos os comunicados
    listar: async (filtros = {}) => {
        try {
            const params = new URLSearchParams();
            if (filtros.ativo !== undefined) {
                params.append('ativo', filtros.ativo.toString());
            }
            const query = params.toString();
            const url = query ? `/comunicados?${query}` : '/comunicados';
            const response = await Api.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao listar comunicados:', error);
            throw error;
        }
    },

    // 2. Pegar 1 comunicado especifico
    obter: async (id) => {
        try {
            const response = await Api.get(`/comunicados/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao obter comunicado:', error);
            throw error;
        }
    },

    // 3. Criar novo comunicado
    criar: async (dados) => {
        try {
            const response = await Api.post('/comunicados', dados);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar comunicado:', error);
            throw error;
        }
    },

    // 4. Desativar comunicado
    desativar: async (id) => {
        try {
            const response = await Api.delete(`/comunicados/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao desativar comunicado:', error);
            throw error;
        }
    },

    // 5. Disparar push (envia para todos destinatarios)
    disparar: async (id) => {
        try {
            const response = await Api.post(`/comunicados/${id}/disparar`);
            return response.data;
        } catch (error) {
            console.error('Erro ao disparar comunicado:', error);
            throw error;
        }
    },

    // 6. Listar respostas (relatorio completo)
    listarRespostas: async (id) => {
        try {
            const response = await Api.get(`/comunicados/${id}/respostas`);
            return response.data;
        } catch (error) {
            console.error('Erro ao listar respostas:', error);
            throw error;
        }
    },

    // 7. Estatisticas (grafico de pizza)
    obterEstatisticas: async (id) => {
        try {
            const response = await Api.get(`/comunicados/${id}/estatisticas`);
            return response.data;
        } catch (error) {
            console.error('Erro ao obter estatisticas:', error);
            throw error;
        }
    },
};

export default ComunicadosService;
